import React, { useEffect, useState } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import { toast } from 'react-toastify';
import { GiExpense } from "react-icons/gi";
import { Button, DatePicker, Input, Select, Table } from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { EmployeeExpensesAdd, EmployeeExpensesDelete, EmployeeExpensesFindAll, EmployeeExpensesUpdate, EmployeeMasterFindAll } from '../Api/All_Api';
import TitleNavbar from '../Navbar/TitleNavbar';

const EmployeeExpense = () => {
  
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];

    const sessionYear = sessionStorage.getItem('sessionYear');
    const year = sessionYear
    
    const branchId = sessionStorage.getItem('branchId');

  
    const navigate = useNavigate();
        useEffect(() => {
          if (!sessionYear) {
            sessionStorage.clear();
            navigate('/')
          }
        },[])
  
  
    const [errors, setErrors] = useState({
      date: "",
      paymentType: "",
      amount: "",
      employee: "",
    });
  
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
  
    const [expensesId, setExpensesId] = useState("");
    const [date, setDate] = useState(dayjs());
    const [paymentType, setPaymentType] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState("");
    const [allEmployeeExpenses, setAllEmployeeExpenses] = useState([]);
    const [updateButton, setUpdateButton] = useState(false);
    const [saveButton, setSaveButton] = useState(true);
    const[allemployees,setAllEmployees]=useState([]);
    const [employee, setEmployee] = useState("");
  
      //======Search data from table===============
      const handleSearch = (value) => {
        const filtered = allEmployeeExpenses.filter((item) =>
          Object.values(item).some((val) =>
            val !== null && val !== undefined && val.toString().toLowerCase().includes(value.toLowerCase())
          )
        );
        setFilteredData(filtered);
        setTotalEntries(filtered.length); // Update total entries count after filtering
        setCurrentPage(1);
      };
      //==========Pagination=======================
      const handlePageSizeChange = (value) => {
        setPageSize(value);
      };
  
    // Fetch Cast Names
    let isExpenseFetched = false;
    useEffect(() => {
        fetchEmployee();
      if (isExpenseFetched) return;
      fetchEmployeeExpenses();
      isExpenseFetched = true;

    }, []);
    
    const fetchEmployee = async () => {
      try {
        const response = await axios.get(`${EmployeeMasterFindAll}?branchId=${branchId}`);
        if (response.data !== null) {
          setAllEmployees(response.data);
        }
        
      } catch (error) {
          if (!isError) {  
            console.error('Error fetching Employee:', error);
            toast.error('Failed to fetch employee data');
            isError = true;  
          }
      }
    };  
  
    // ==============Get table data================
  
    let isError = false;
  
    const fetchEmployeeExpenses = async () => {
   
      try {
        const response = await axios.get(`${EmployeeExpensesFindAll}?branchId=${branchId}&accYear=${year}`);
        if (response.data !== null) {
          setAllEmployeeExpenses(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
      } catch (error) {
        if (!isError) {
          // Check if the error has already been triggered
          console.error("Error fetching Expenses Entry:", error);
          toast.error("Failed to fetch Expenses Entry data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
  
    const columns = [
      {
        title: "Sr.No.",
        dataIndex: "",
        key: "index",
        render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      },
      {
        title: "Date",
        dataIndex: "employeePaymentDate",
        key: "employeePaymentDate",
      },
      {
        title: "Employee Name",
        dataIndex: "employeeName",
        key: "employeeName",
      },
      {
        title: "Payment Type",
        dataIndex: "paymentType",
        key: "paymentType",
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "Edit",
        key: "edit",
        render: (text, record) => (
          <div className=''>
            <span
              type="submit"
              id={`edit-tooltip-${record.id}`}
              style={{ fontSize: "12px", color: "orange", marginRight: "10px" }}
              onClick={() => handleEditDataButton(record)}
            
            >
              <i class="fa-solid fa-pen-to-square"></i>
            </span>
            <Tooltip
              anchorId={`edit-tooltip-${record.id}`}
              content="Edit"
              place="top"
            />
          </div>
        ),
      },
      {
        title: "Delete",
        key: "delete",
        render: (text, record) => (
          <div className=''>
            <span
              type="submit"
              id={`delete-tooltip-${record.id}`}
              style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
              onClick={() => handleDeleteData(record)}
            >
             <i class="fa-solid fa-trash"></i>
            </span>
            <Tooltip
              anchorId={`delete-tooltip-${record.id}`}
              content="Delete"
              place="top"
            />
          </div>
        ),
      },
    ];
  
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "10px",
              fontSize: "13px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
            }}
          >
            {children}
          </td>
        ),
      },
    };
  
    // ========Cancel data save==================
    const handleCancel = () => {
      setUpdateButton(false);
      setSaveButton(true);
      setDate(dayjs());
      setPaymentType("");
      setDescription("");
      setAmount("");
      setEmployee("");
      setErrors("");
      fetchEmployeeExpenses();
    };
  
    // ========Submit data to table==============
    const handleSubmit = async () => {
      let isValid = true;
      const errorObj = {};
  
      if (!date) {
        isValid = false;
        errorObj.date = "Date is required *";
      }
      if (!paymentType) {
        isValid = false;
        errorObj.paymentType = "Payment Type is required *";
      }
      if (!employee) {
        isValid = false;
        errorObj.employee = "Employee is required *";
      }
      if (!description) {
        isValid = false;
        errorObj.description = "Description is required *";
      }
      if (!amount) {
        isValid = false;
        errorObj.amount = "Amount is required *";
      }
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
  
      const formattedDate = date
      ? dayjs(date).format("DD/MM/YYYY")
      : "";
  
      const bodyData = {
        employeePaymentDate: formattedDate,
       paymentType: paymentType,
       employeeId:employee,
        description: description,
        amount: parseFloat(amount),
        accYear:parseInt(year),
      branchId:parseInt(branchId),
      };
  
      try {
        const response = await axios.post( EmployeeExpensesAdd,bodyData);
  
        if (response.data === "CREATED") {
          toast.success("Expense added Successfully!");
          fetchEmployeeExpenses();
          handleCancel();
        } else if (response.data === "ALREADYEXISTS") {
          toast.warn("Expense  Already Exist !");
          handleCancel();
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while submitting data");
      }
    };
    
  
    // ========Update data from table============
    const handleEditDataButton = (item) => {
      setUpdateButton(true);
      setSaveButton(false);
      window.scrollTo(0, 0);
      setDate(item.employeePaymentDate ? dayjs(item.employeePaymentDate, 'DD/MM/YYYY') : null);
      setPaymentType(item.paymentType); 
      setDescription(item.description); 
      setAmount(item.amount); 
      setExpensesId(item.id);
      setEmployee(item.employeeId);
    };
  
    const handleUpdate = async () => {
      let isValid = true;
      const errorObj = {};
  
      if (!date) {
        isValid = false;
        errorObj.date = "Date is required *";
      }
      if (!paymentType) {
        isValid = false;
        errorObj.paymentType = "Payment Type is required *";
      }
      if (!employee) {
        isValid = false;
        errorObj.employee = "Employee is required *";
      }
      if (!description) {
        isValid = false;
        errorObj.description = "Description is required *";
      }
      if (!amount) {
        isValid = false;
        errorObj.amount = "Amount is required *";
      }
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
  
      const formattedDate = date
      ? dayjs(date).format("DD/MM/YYYY")
      : "";
  
      const bodyData = {
        id: expensesId,
        employeePaymentDate: formattedDate,
        paymentType: paymentType,
        employeeId:employee,
        description: description,
        amount: parseFloat(amount),
      };
  
      try {
        const response = await axios.put( EmployeeExpensesUpdate,bodyData);
  
        if (response.data === "UPDATED") {
          toast.success("Expense  Updated!");
          fetchEmployeeExpenses();
          handleCancel();
        } else if (response.data === "ALREADYEXISTS") {
          toast.warn("Expense  Already Exist!");
          handleCancel();
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while updating data");
      }
    };
  
    const handleDeleteData = async (item) => {
      const confirmDelete = window.confirm(
        `Are you sure you want to delete the Employee Expense  "${item.employeeName}"?`
      );
      if (!confirmDelete) return;
  
      try {
        const response = await axios.delete(`${EmployeeExpensesDelete}?id=${item.id}`);
         
        
        if (response.data === "DELETED") {
          toast.success("Expense  Deleted !");
          fetchEmployeeExpenses();
        }
      } catch (error) {
        console.error("Error during delete operation:", error);
        toast.error("Error occurred while deleting the Expense ");
      }
    };
  
  //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================
  
    return (
      <>
        <AdminNavbar />
  
      <div className="p-0 m-0">
  
          <div
            className="row m-0"
            style={navbg}
          >
            <div
              className="col-12 "
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <span className="px-md-5" style={{ flexGrow: 1}}>
                {" "}
                <GiExpense /> &nbsp; Employee Expenses
              </span>
              <span >
            <TitleNavbar />
            </span>
            </div>
  
    
          </div>
  
          <div className='row m-0 p-0 pt-5'>
            <div className='col-12 col-lg-3'></div>
            <div className='col-12 col-lg-6'>
                <div className="row px-md-5 mt-3  m-0">
  
                <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div className="col-3 p-0 lableStyle">
                        <label className="labels">Date :</label>
                      </div>
                      <div className="col-9 col-md-4">
                      <DatePicker
                          defaultValue={null}
                          value={date}
                          onChange={(value) => setDate(value)}
                          className="w-100"
                          format={dateFormatList}
                        />
                          {errors.date && (
                            <div className="errorField">{errors.date}</div>
                          )}
                      </div>
                    </div>
                  </div>
                    
                  <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div className="col-3 p-0 lableStyle">
                        <label className="labels">Employee:</label>
                      </div>
                      <div className="col-7 ">
                           <Select
                       value={employee || undefined}
                       onChange={setEmployee}
                           showSearch
                      className="w-100"
                     placeholder="Select Employee"
                       optionFilterProp="children">
                                {allemployees.map(p => (
                                  <Select.Option key={p.id} value={p.id}>
                                    {p.employeeName}
                                  </Select.Option>
                                ))}
                              </Select>
                          {errors.employee && (
                            <div className="errorField">{errors.employee}</div>
                          )}
                      </div>
                    </div>
                  </div>
  
                  <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div className="col-3 p-0 lableStyle">
                        <label className="labels">Payment Type :</label>
                      </div>
                      <div className="col-9 col-md-4">
                      <Select
                       value={paymentType || undefined}
                       onChange={(value) => setPaymentType(value)}
                           showSearch
                      className="w-100"
                     placeholder="Select Type"
                       optionFilterProp="children">
                                  <Select.Option value="Salary">
                                  Salary
                                  </Select.Option>
                                  <Select.Option value="Advance">
                                   Advance
                                  </Select.Option>
                                  <Select.Option value="Medical">
                                   Medical
                                  </Select.Option>
                                  <Select.Option value="Other">
                                   Other
                                  </Select.Option>
                              </Select>
                             
                          {errors.paymentType && (
                            <div className="errorField">{errors.paymentType}</div>
                          )}
                      </div>
                    </div>
                  </div>
                
                  <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div className="col-3 p-0 lableStyle">
                        <label className="labels">Description:</label>
                      </div>
                      <div className="col-7">
                      <TextArea
                       maxLength="255"
                            value={description || ''}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                          />
                          {errors.description && (
                            <div className="errorField">{errors.description}</div>
                          )}
                      </div>
                    </div>
                  </div>
  
                  <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div className="col-3 p-0 lableStyle">
                        <label className="labels">Amount :</label>
                      </div>
                      <div className="col-9 col-md-4">
                         <Input
                            value={amount || ''}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter Amount"
                            onKeyPress={(e) => {
                            // Prevent non-numeric characters from being entered
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          />
                          {errors.amount && (
                            <div className="errorField">{errors.amount}</div>
                          )}
                      </div>
                    </div>
                  </div>
  
                  <div className="col-12 text-center pt-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    {saveButton && (
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                    )}
                    {updateButton && (
                      <Button
                        type="submit"
                        className="UpdateBtn mx-1"
                        onClick={handleUpdate}
                      >
                        Update
                      </Button>
                    )}
                  </div>
  
                  <div
                    className="col-12 p-0 mt-3"
                    style={{ borderBottom: "2px solid #bfb597" }}
                  ></div>
                </div>
            </div>
            <div className='col-12 col-lg-3'></div>
          </div>
          {/*================ Table =========================*/}
          <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
          <div className='col-12 col-md-2'></div>
            <div  className="col-12 col-md-8 py-3 shadow border"
              style={{ marginBottom: "50px", backgroundColor: "white" }}
            >
              <div
                className="col-12 px-md-5"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                  <Select
                    defaultValue={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: 120, textAlign: "center" }}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={30}>30</Option>
                  </Select>
                </div>
  
                <div className="pt-4 pt-md-0">
                  <Input.Search
                    placeholder="Search"
                    onSearch={handleSearch}
                    style={{ width: 200, marginBottom: 16 }}
                  />
                </div>
              </div>
  
              <div style={{ backgroundColor: "white" }}>
                <Table
                  bordered
                  style={{ padding: "0px 20px", overflowX: "auto" }}
                  columns={columns}
                  dataSource={filteredData}
                  pagination={{
                    pageSize: pageSize,
                    total: totalEntries,
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                    current: currentPage,
                    onChange: (page) => setCurrentPage(page),
                  }}
                  showSorterTooltip={false}
                  rowKey={(record) => record.id}
                  components={components}
                />
              </div>
            </div>
            <div className='col-12 col-md-2'></div>
          </div>
        </div>
  
      </>
    )

}

export default EmployeeExpense